// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bs-2";
export var aiChatCartContainerExit = "_bs-4";
export var aiChatContainerLarge = "_bs-0";
export var aiChatContainerSmall = "_bs-1";
export var aiChatIcon = "_bs-6";
export var slideInFromRight = "_bs-3";
export var slideOutToRight = "_bs-5";